<template>
  <div class="comps-cardb-item"
    :class="{'comps-cardb-item-hover' : hoverIndex}"
    @mouseover="hoverIndex = true"
    @mouseout="hoverIndex = false"
    @click="$emit('click')">
    <div class="icon centerimage" ref="backimg" v-if="imgurla"
      :style="'background-image: url(' + (hoverIndex ? imgurla : imgurlb) + ')'"><!-- 背景图 --></div>
    <div class="icon gray-bg" ref="backimg" v-else><!-- 背景图 --></div>
    <h2 class="title to-1" v-if="title">{{title}}</h2>
    <h2 class="title" v-else>
      <span class="dis-bl ht-30 gray-bg wi-120 mg-a"></span>
    </h2>
    <div class="border"></div>
    <p class="info to-4" v-if="info">{{info}}</p>
    <p class="info to-4" v-else>
      <span class="dis-bl ht-20 gray-bg mb-4"></span>
      <span class="dis-bl ht-20 gray-bg mb-4"></span>
      <span class="dis-bl ht-20 gray-bg"></span>
    </p>
  </div>
</template>

<script>
export default {
  props: {
    imgurla: {
      type: String,
      default: ''
    },
    imgurlb: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    info: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      hoverIndex: false
    }
  }
}
</script>

<style lang="less" scoped>
  @import url('../../../utils/color.less');
  .comps-cardb-item {
    width: 100%;
    background-color: #FFF;
    -webkit-transition: 0.1s;
    transition: 0.1s;
    padding: 50px;
    .icon {
      width: 140px;
      height: 140px;
      margin: auto;
    }
    .title {
      font-family: Georgia, 宋体;
      font-weight: bold;
      text-align: center;
      margin: 20px 0 10px;
    }
    .info {
      text-align: center;
      margin: 0;
      height: 83px;
    }
    .border {
      width: 40px;
      margin: 16px auto 20px;
      border-top: @primary solid 2px;
    }
  }
  .comps-cardb-item-hover {
    background-color: @primary;
    cursor: pointer;
    .title {
      color: #FFF;
    }
    .info {
      color: #FFF;
      opacity: 0.6;
    }
    .border {
      border-color: #FFF;
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/Models/comps/cardAreas.vue